/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for parameterDataType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="parameterDataType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="boolean"/&gt; &lt;enumeration value="string"/&gt; &lt;enumeration value="integer"/&gt; &lt;enumeration value="decimal"/&gt; &lt;enumeration value="datetime"/&gt; &lt;enumeration value="time"/&gt; &lt;enumeration value="date"/&gt; &lt;enumeration value="interval"/&gt; &lt;enumeration value="memberUniqueName"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class ParameterDataType extends Enum{

	enumValue = null;

	static  BOOLEAN = ParameterDataType.newLiteral("boolean");

	static  STRING = ParameterDataType.newLiteral("string");

	static  INTEGER = ParameterDataType.newLiteral("integer");

	static  DECIMAL = ParameterDataType.newLiteral("decimal");

	static  DATETIME = ParameterDataType.newLiteral("datetime");

	static  TIME = ParameterDataType.newLiteral("time");

	static  DATE = ParameterDataType.newLiteral("date");

	static  INTERVAL = ParameterDataType.newLiteral("interval");

	static  MEMBER_UNIQUE_NAME = ParameterDataType.newLiteral("memberUniqueName");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < ParameterDataType.values().length); ++i) {
			if (ParameterDataType.values()[i].enumValue == v) {
				return ParameterDataType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("ParameterDataType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/ParameterDataType.js